var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',{staticClass:"checkout-button__button",attrs:{"variant":"success","type":"submit","disabled":_vm.modifyingOrSubmittingOrder,"data-vs-tracking":"pay-now-button"},on:{"click":_vm.submitOrder}},[(!_vm.submittingOrder)?_c('span',[_vm._v(" Pay Now ")]):_c('BSpinner',{attrs:{"small":"","label":"processing order"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }